import { render } from "./delete.vue?vue&type=template&id=6d8acf5c&scoped=true"
import script from "./delete.vue?vue&type=script&lang=js"
export * from "./delete.vue?vue&type=script&lang=js"

import "./delete.vue?vue&type=style&index=0&id=6d8acf5c&scoped=true&lang=css"

import exportComponent from "/etc/ec/hepi/hepi_ui_2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d8acf5c"]])

export default __exports__